import { stakingAbi } from '../../abis/stakingAbi'
import { tokenAbi } from '../../abis/tokenAbi'
import { zkAbi } from '../../abis/zkAbi'
import { parseJson } from '../app/app.helpers'
import { nextTargetTime } from '../date.helpers'
import { formatCurrencyShort } from '../number.helpers'
import { toLower } from '../string.helpers'

const STAKING_APY = 12
const getContractsAddresses = () => {
  return parseJson(process.env.REACT_APP_CONTRACT_ADDRESS)
}

const contractConfig = getContractsAddresses()

const tokenContractConfig = () => {
  return {
    address: contractConfig?.token,
    abi: tokenAbi
  }
}

const stakingContractConfig = () => {
  return {
    address: contractConfig?.staking,
    abi: stakingAbi
  }
}

const zkContractConfig = () => {
  return {
    address: contractConfig?.zk,
    abi: zkAbi
  }
}

const isWalletConnected = ({ isConnected, address }) => {
  return isConnected && address
}

const disconnectMetamaskWallet = () => {
  localStorage.setItem('wagmi.io.metamask.disconnected', true)
  localStorage.setItem('wagmi.metaMask.disconnected', true)
}

const nextClaimTime = () => {
  return nextTargetTime('', 0)
}

const CURRENCIES = {
  QBX: 'QBX',
  VIR: 'VIR',
  CHF: 'CHF',
  EUR: 'EUR',
  USD: 'USD'
}

const formatQBXCurrency = (value) => {
  return `${value ? formatCurrencyShort(value, 3) : 0} ${CURRENCIES.QBX}`
}

const getTxnLog = (logs, address) => {
  return logs && logs.find((log) => toLower(log.address) === toLower(address))
}

const membershipLabel = ({ t, id, name }) => {
  return t(`brand:staking.${id === 1 ? 'starter' : 'level'}-title`, {
    number: id - 1,
    name
  })
}

const membershipLevelLabel = ({ t, id }) => {
  return t(`brand:staking.${id === 1 ? 'starter' : 'level'}`, {
    number: id - 1
  })
}

const findNextLevel = (threshold, data) => {
  let index = data.findLastIndex((item) => item.fiatThreshold <= threshold)
  return index !== -1 && index + 1 < data.length ? data[index + 1] : null
}

const ONYX_LEVEL_ID = 2
const EMERALD_LEVEL_ID = 4

const findTierLevelById = (data, tierId) => {
  return data.find(({ id }) => id >= tierId)
}

export {
  STAKING_APY,
  contractConfig,
  CURRENCIES,
  disconnectMetamaskWallet,
  EMERALD_LEVEL_ID,
  findNextLevel,
  findTierLevelById,
  formatQBXCurrency,
  getContractsAddresses,
  getTxnLog,
  isWalletConnected,
  membershipLabel,
  membershipLevelLabel,
  nextClaimTime,
  ONYX_LEVEL_ID,
  stakingContractConfig,
  tokenContractConfig,
  zkContractConfig
}
